import { ECrmType } from '@webtrader/core/enum/crm';
import request from '@webtrader/core/request';

export interface IRequestOtpParams {
  crmType?: ECrmType;
  clientPortalUrl?: string;
  email?: string;
  phoneNumber?: string;
  countryCode?: string;
  type: EOTPType;
}

export enum EOTPType {
  SMS = 1,
  EMAIL = 2
}

interface IRequestOtpResponse {
  sessionId: string;
  userId: string;
  message: string;
  createdTime: number;
  expiryTime: number;
  timeoutInSec: number;
}

const requestOtp = (params: IRequestOtpParams) => {
  return request.post<IRequestOtpResponse>('/api/auth/v1/otp/verification', params);
};

export default requestOtp;
